
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalBoard as ObiBuoyConicalBoardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-board.js';
 
 
 

 
 export const ObiBuoyConicalBoard = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-board',
   elementClass: ObiBuoyConicalBoardElement,
   events: {
     
   }
  });
 
 